import { apiService } from "../../../../../services/api";

export const getPools = async () => {
  return await apiService.get(`/approver-pools/`);
};
export const createPools = async (payload: any) => {
  return await apiService.post(`/approver-pools/`, payload);
};
export const updatePools = async (poolId: any, payload: any) => {
  return await apiService.put(`/approver-pools/${poolId}`, payload);
};
export const deletePools = async (poolId: any) => {
  return await apiService.delete(`/approver-pools/${poolId}`);
};
export const createApprovalFlowApi = async (payload: any) => {
  return await apiService.post(`/approval-flows/`, payload);
};
export const getApprovals = async () => {
  return await apiService.get(`/approval-flows/`);
};
export const updateApprovals = async (approvalId: any, payload: any) => {
  return await apiService.put(`/approval-flows/${approvalId}`, payload);
};
export const updateApprovalLevel = async (
  flowId: string,
  levelId: string,
  payload: any,
) => {
  return await apiService.put(
    `/approval-flows/${flowId}/levels/${levelId}`,
    payload,
  );
};

export const deleteApprovals = async (approvalId: any) => {
  return await apiService.delete(`/approval-flows/${approvalId}`);
};
export const detailsApproval = async (flowId: string) => {
  return await apiService.get(`/approval-flows/${flowId}`);
};
export const getPoolDetails = async (poolId: string) => {
  return await apiService.get(`/approver-pools/${poolId}`);
};
